import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

const FALLBACK_LABELS: Record<string, string> = {
  new_feature: 'New Feature',
  improvement: 'Improvement',
  bug_fix: 'Bug Fix',
  draft: 'Draft',
  published: 'Published',
  archived: 'Archived',
  completed: 'Completed',
  viewed: 'Viewed',
  ignored: 'Ignored',
  not_viewed: 'Not Viewed',
};

/** Coloured pill for a release type, release status or engagement action (Remmi Releases design D1). */
@Component({
  selector: 'app-release-pill',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="release-pill" [ngClass]="'release-pill--' + value">{{ label || fallbackLabel }}</span>`,
  styleUrls: ['./release-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReleasePillComponent {
  /** API key, e.g. `new_feature`, `published`, `not_viewed` — picks the colour. */
  @Input() value: string;
  /** API label (`type_label`, `status_label`, `action_label`); falls back to a built-in one. */
  @Input() label: string;

  get fallbackLabel(): string {
    return FALLBACK_LABELS[this.value] ?? this.value;
  }
}
